/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ActualDetailsTable_project = {
    readonly fixedPriceLocks: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly startDate: string | null;
                readonly endDate: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"DetailsTable_project">;
    readonly " $refType": "ActualDetailsTable_project";
};
export type ActualDetailsTable_project$data = ActualDetailsTable_project;
export type ActualDetailsTable_project$key = {
    readonly " $data"?: ActualDetailsTable_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ActualDetailsTable_project">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "fixedPriceLocks"
        ]
      }
    ]
  },
  "name": "ActualDetailsTable_project",
  "selections": [
    {
      "alias": "fixedPriceLocks",
      "args": null,
      "concreteType": "ProjectFixedPriceLockTypeConnection",
      "kind": "LinkedField",
      "name": "__Project_fixedPriceLocks_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectFixedPriceLockTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectFixedPriceLockType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DetailsTable_project"
    }
  ],
  "type": "ProjectType"
};
(node as any).hash = '112d321814926bf285c35e75a89b632d';
export default node;
